import * as React from 'react';
import Link from '@mui/material/Link';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import SuccessSnackbar from '../../../../../shared/feedback/SuccessSnackbar';
import FailureSnackbar from '../../../../../shared/feedback/FailureSnackbar';
import { Translate } from "../../../../../shared/LanguageService";

type MatterportBrokerLabels = {
    copyLink: string;
    successCopy: string;
    failureCopy: string;
};

type MatterportBrokerProps = {
    link: string;
    labels: MatterportBrokerLabels;
};

type ExternalProps = {
    link: string;
}

function MatterportBroker({ labels, link }: MatterportBrokerProps) {
    let [showSuccessSnackbar, setShowSuccessSnackbar] = React.useState(false);
    let [showFailureSnackbar, setShowFailureSnackbar] = React.useState(false);

    async function handleClickCopyLink() {
        // @ts-ignore
        if (navigator.clipboard) {
            // @ts-ignore
            await navigator.clipboard.writeText(link);
            setShowSuccessSnackbar(true);
        } else {
            setShowFailureSnackbar(true);
        }
    }

    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                gap: '12px'
            }}
        >
            <Paper
                sx={{
                    padding: '8px',
                    minWidth: '30%'
                }}
            >
                <Link
                    href={link}
                    sx={{
                        fontSize: '20px',
                        padding: '8px'
                    }}
                >
                    {link}
                </Link>
            </Paper>
            <Button variant="contained" onClick={handleClickCopyLink} endIcon={<ContentCopyIcon />}>
                {labels.copyLink}
            </Button>
            <SuccessSnackbar
                open={showSuccessSnackbar}
                onClose={() => {
                    setShowSuccessSnackbar(false);
                }}
                text={labels.successCopy}
            />
            <FailureSnackbar
                open={showFailureSnackbar}
                onClose={() => {
                    setShowFailureSnackbar(false);
                }}
                text={labels.failureCopy}
            />
        </Box>
    );
}

export default function TranslatedMatterportBroker({
    link
}: ExternalProps ) {
    let labels: MatterportBrokerLabels = {
        copyLink: Translate('view-order/basic-order-info/matterport/broker/button/copy-link'),
        successCopy: Translate('view-order/basic-order-info/matterport/broker/success-snackbar'),
        failureCopy: Translate('view-order/basic-order-info/matterport/broker/failure-snackbar')
    };
    
    return <MatterportBroker link={link} labels={labels} />;
}
